<template>
  <SiteIndex v-if="!native && model" :model="model" :white-list="[]" />
  <site-shop-cart v-else-if="(native === PageNameEnum.SHOP_CART) && model" :model="model" />
  <site-coupon v-else-if="(native === PageNameEnum.COUPON) && model" :model="model" />
</template>

<script>
import cloneDeep from "lodash.clonedeep";
import SiteCore, {postReady, getSiteBuilderDataByService, initPwa, checkLogin, getIpInfo } from "~/site/core"
import SiteIndex from "~/site/components/siteIndex"
import SiteShopCart from "~/site/components/shopCartPage/index.vue";
import SiteCoupon from '~/site/components/couponPage/index.vue'
import {useAssets} from "~/hooks/useAssets";
import langConfigMixins from "~/mixins/langConfigMixins";
import {PageNameEnum} from "~/enums/pageEnum";
import {insertScript} from "~/utils/dom"
import tools from "~/utils";

export default {
  name: "SitePreview",
  components: {
    SiteIndex,
    SiteShopCart,
    SiteCoupon
  },
  mixins: [langConfigMixins],
  layout: 'defaultLayout',
  async asyncData({redirect, app, params, route, store}) {
    return await getSiteBuilderDataByService({redirect, app, route, params, store})
  },
  data() {
    return {
      native: null,
      model: null,
      lang: '',
      mid: '',
      pid: '',
      domain: '',
      pLang: '',
      langIdData: {},
      siteBuildId: '',
      siteInfo: {},
      baseInfo: {},
      pageList: [],
      web: {},
      pwa: {},
      languages: []
    }
  },
  head() {
    const site = this.siteInfo.conf.web.site
    return {
      title: site?.seoSetting.title || '',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: site?.seoSetting.desc || '',
        },
        {
          hid: 'viewport',
          name: 'viewport',
          content: 'width=device-width,initial-scale=1,user-scalable=no',
        },
      ],
      link: [
        {
          rel: 'icon',
          hid: 'favicon.ico',
          type: 'image/x-icon',
          href: site?.seoSetting.favicon || '',
        }
      ]
    }
  },
  computed: {
    PageNameEnum() {
      return PageNameEnum
    }
  },
  beforeDestroy() {
    this.pwa.off()
  },
  mounted() {
    const {setSiteLangList} = useAssets(this)
    setSiteLangList(this.langList)
    this.setNewUrl()
    this.pwa = initPwa(this)
  },
  methods: {
    setConsole() {
      insertScript({
        src: 'https://unpkg.com/vconsole@latest/dist/vconsole.min.js'
      }, () => {})
    },
    // 设置语言
    async setNewUrl() {
      const params = tools.getNeedParamsFormRouteParams(this.$route.params)
      this.native = params.native
      if (!params.lang && !params.native) {
        const {params, path, query} = this.$route
        const {sid, pageid} = tools.getNeedParamsFormRouteParams(params)
        const prefix = path.includes('/preview') ? `/preview/${sid}` : ''
        const page_id = pageid === '/' ? '' : `${pageid}`
        const sysLang = tools.getSysLanguage()
        const langArr = this.langList?.map(item => item.code) || []
        const curLang = langArr.includes(sysLang) ? sysLang : this.siteInfo.default_language
        this.pLang = curLang
        let queryParams = ''
        for (const key in query) {
          const value = query[key]
          if (value) {
            queryParams = `${queryParams}&${key}=${value}`
          }
        }
        const fullPath = `${prefix}/${curLang}/${page_id}?${queryParams}`
        await this.$router.push(fullPath)
      } else {
        this.pLang = params.lang
        await this.init()
      }
      this.$cookies.set('lang', this.pLang)
      tools.setFavicon(this.siteInfo.conf.web.site?.seoSetting.favicon)
      tools.setPageTitle()
    },
    async getCurrencies() {
      const res = await this.$api.common.getCurrencies()
      const map = {}
      res.data.forEach((c) => {
        map[c.id] = c
      })
      this.$store.commit('project/SET_CURRENCYINFO', {
        currency: res.data,
        currencieMap: map,
      })
    },
    async init() {
      try {
        await checkLogin(this)
        await getIpInfo(this)
        await this.getCurrencies()
        this.$store.commit('editor/SET_EDIT_MODE', false)
        const {baseInfo, siteInfo, languages, langList, pageList} = this
        const lang = this.pLang || this.siteInfo.default_language
        this.langIdData = await this.getLangConfig(lang, this.siteInfo.default_language, this.pid)
        this.model = new SiteCore({
          editMode: false,
          baseInfo,
          siteInfo: siteInfo.conf,
          languages,
          langList,
          lang,
          langIdData: this.langIdData,
          pageList,
        })
        this.$store.commit('locale/SET_LANG', this.pLang || this.siteInfo.default_language)
        this.$store.commit('locale/SET_LANG_DATA', cloneDeep(this.langIdData))
        tools.setPageTitle(this.web.site.seoSetting, this.langIdData)
        this.$nextTick(() => {
          postReady()
        })
      } catch (error) {
        return Promise.reject(error)
      }
    },

  }
}
</script>
